import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';

import { IBusinessPlanEntity } from 'interfaces/businessPlan';

import { BusinessPlanProjectCard } from '../components/ProjectCards/BusinessPlanProjectCard/BusinessPlanProjectCard';
import { OnePageCard } from '../components/ProjectCards/OnePage/OnePage';

interface IBusinessPlanCard {
  props: IBusinessPlanEntity;
  pictureUrl?: string;
  coverTitle?: string;
  isPictureLoading?: boolean;
  companyName?: string;
}

export const getBusinessPlanCard = ({
  props,
  pictureUrl,
  coverTitle,
  isPictureLoading,
  companyName,
}: IBusinessPlanCard) => {
  const businessPlanCardMap = {
    [BUSINESS_PLAN_TYPES.ONE_PAGE]: <OnePageCard {...props} key={coverTitle} />,
    [BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT]: <OnePageCard {...props} key={coverTitle} />,
    [BUSINESS_PLAN_TYPES.FOR_BANK]: (
      <BusinessPlanProjectCard
        {...props}
        key={coverTitle}
        coverTitle={coverTitle}
        picture={pictureUrl}
        isPictureLoading={isPictureLoading}
        companyName={companyName}
      />
    ),
    [BUSINESS_PLAN_TYPES.FOR_INVESTORS]: (
      <BusinessPlanProjectCard
        {...props}
        key={coverTitle}
        coverTitle={coverTitle}
        picture={pictureUrl}
        isPictureLoading={isPictureLoading}
        companyName={companyName}
      />
    ),
  };

  return businessPlanCardMap[props.type] || null;
};
